import React from 'react';
import history from 'history.js';
import PropTypes from 'prop-types';
import snakeCase from 'lodash/snakeCase';
import { connect } from 'react-redux';
import queryString from 'query-string';
import API from 'shared/constants/api';
import snakeCaseKeys from 'snakecase-keys';
import { bindActionCreators } from 'redux';
import { toLocalized } from 'shared/helpers/locale';
import { correctionYears } from 'shared/helpers/users';
import { enqueueNotification } from 'shared/actions/notifications';
import { setRedirectUrl, clearRedirectUrl } from 'shared/actions/globals';
import { setSavedSearches, setShowSaveSearchBtn } from 'shared/actions/user';
import { generateSearchQuery, generateSearchUrl } from 'shared/helpers/urls';
import { getDisplayName } from '../helpers/common';
import { withFetch } from './withFetch';

const withSubscriptionSearch = WrappedComponent => {
  const Component = class extends React.Component {
    static displayName = `withSubscriptionSearch(${getDisplayName(WrappedComponent)})`;

    static propTypes = {
      user: PropTypes.shape(),
      onChangeSaveSearchBtn: PropTypes.func.isRequired,
      enqueueNotif: PropTypes.func.isRequired,
      setSearches: PropTypes.func.isRequired,
      redirectUrl: PropTypes.string.isRequired,
      clearRedUrl: PropTypes.func.isRequired,
      setRedUrl: PropTypes.func.isRequired,
      location: PropTypes.shape(),
      formState: PropTypes.shape().isRequired,
      savedSearches: PropTypes.arrayOf(PropTypes.shape()).isRequired,
      isFirstRender: PropTypes.bool,
      //
      fetch: PropTypes.func.isRequired,
      t: PropTypes.func.isRequired,
    };
    static defaultProps = {
      isFirstRender: false,
      location: null,
      user: {},
    };

    state = {
      savedSearch: null,
    };

    componentDidMount = () => {
      const { redirectUrl, clearRedUrl, isFirstRender } = this.props;

      if (redirectUrl && this.verifySavedSearch() && isFirstRender) {
        clearRedUrl();
      } else if (redirectUrl && isFirstRender) {
        this.saveSearch();
        clearRedUrl();
      }
    };

    setSavedSearchToState = data => this.setState({ savedSearch: data });

    hideSavedSearch = () => {
      const { onChangeSaveSearchBtn } = this.props;

      onChangeSaveSearchBtn(false);
      this.setSavedSearchToState(null);
    };

    verifySavedSearch = () => {
      const { formState, savedSearches, location } = this.props;

      const editedFormState = { ...formState, ...correctionYears(formState) };
      const rewrittenKeys = {};

      Object.keys(editedFormState).map(
        // eslint-disable-next-line no-return-assign
        key => (rewrittenKeys[snakeCase(key)] = editedFormState[key]),
      );

      let pathname = generateSearchUrl(
        { ...rewrittenKeys, location },
        location && location.is_country,
      );

      pathname = pathname.substring(0, pathname.length - 1);

      const query = generateSearchQuery(rewrittenKeys);
      const searchUrl = `/${pathname}?${queryString.stringify(query)}`;

      return savedSearches.find(item => item.link === searchUrl) || null;
    };

    saveSearch = () => {
      const {
        t,
        enqueueNotif,
        formState,
        user,
        fetch,
        location,
        setSearches,
        savedSearches,
        setRedUrl,
      } = this.props;
      const token = user && user.token;

      const editedFormState = { ...formState, ...correctionYears(formState) };
      const query = generateSearchQuery(editedFormState);

      if (token) {
        fetch(API.ADVERT.SEARCH_SUB, {
          method: 'POST',
          body: JSON.stringify({ query: queryString.stringify(snakeCaseKeys(query)) }),
          headers: {
            Authorization: `JWT ${token}`,
          },
        })
          .then(r => r.json())
          .then(data => {
            if (data && data.id) {
              setSearches([...savedSearches, { ...data }]);
              enqueueNotif(t('Подписка оформлена'));
              this.setSavedSearchToState(data);
            }
          });
      } else {
        const pathname = generateSearchUrl(
          { ...editedFormState, location },
          location && location.is_country,
        );
        const redirectUrl = `/${pathname}?${queryString.stringify(query)}`;
        const locale = t('locale') === 'uk' ? '/uk' : '';

        setRedUrl(redirectUrl);
        history.push(toLocalized(`${locale}/my`));
      }
    };

    render() {
      return (
        <WrappedComponent
          {...this.props}
          saveSearch={this.saveSearch}
          verifySavedSearch={this.verifySavedSearch}
          setSavedSearchToState={this.setSavedSearchToState}
          savedSearch={this.state.savedSearch}
          hideSavedSearch={this.hideSavedSearch}
        />
      );
    }
  };

  const mapStateToProps = ({ user, searchForm, globals }) => ({
    formState: searchForm && searchForm.selected,
    location: globals.location,
    savedSearches: user.savedSearches || [],
    redirectUrl: globals.redirectUrl,
    showSaveSearchBtn: user.showSaveSearchBtn,
    user,
  });

  const mapDispatchToProps = dispatch => ({
    setSearches: bindActionCreators(setSavedSearches, dispatch),
    enqueueNotif: bindActionCreators(enqueueNotification, dispatch),
    setRedUrl: bindActionCreators(setRedirectUrl, dispatch),
    clearRedUrl: bindActionCreators(clearRedirectUrl, dispatch),
    onChangeSaveSearchBtn: bindActionCreators(setShowSaveSearchBtn, dispatch),
  });

  return connect(mapStateToProps, mapDispatchToProps)(withFetch(Component));
};

export default withSubscriptionSearch;



// WEBPACK FOOTER //
// ./src/shared/hocs/withSubscriptionSearch.js